import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  colors} from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';

import { Label } from 'components';
import Table from 'components/Table/Table'
import { GroupRepoDTO } from 'dto/GroupDTO';

interface RepositoriesProps {
  className?: string,
  group: GroupRepoDTO,
  title?: string,
  onShareRepository?: (shared: boolean, id: number) => void
}

const Repositories = (props: RepositoriesProps) => {
  const { className, group, onShareRepository, title } = props;

  const [open, setOpen] = useState<boolean>(true);

  const repositories = useMemo(() => group.allRepositories.map(repo => ({
    ...repo,
    shared: group.repositories.some(shared => shared.id === repo.id)
  })), [group])

  return (
    <Table
      additionalColumns={[{
        cell: (item) => <Button
          color="primary"
          endIcon={<ShareIcon />}
          onClick={() => onShareRepository(item.shared, item.id)}
          size="small"
          variant={item.shared ? 'outlined' : 'contained'}
        >
          {item.shared ? 'unshare' : 'share'}
        </Button>,
        header: 'actions',
        id: 'actions',
        cellProps: { align: 'center' },
        headerProps: { align: 'center' }
      }]}
      cellMap={{
        shared: (item) => <Label color={item.shared ? colors.green[500] : colors.red[500]}>
          {item.shared ? 'shared' : 'unshared'}
        </Label>,
        description: (item) => item.description || '-'
      }}
      cellProps={{
        shared: { align: 'center' }
      }}
      classes={{root: className}}
      data={repositories}
      filters={{
        name: {
          type: 'input'
        },
        description: {
          type: 'input'
        },
        shared: {
          type: 'options',
          options: [{
            key: true,
            value: 'Shared'
          }, {
            key: false,
            value: 'Unshared'
          }]
        }
      }}
      headerAlign={{
        shared: 'center'
      }}
      headerMap={{
        shared: 'status'
      }}
      headers={['name', 'description', 'shared']}
      idKey='id'
      open={open}
      setOpen={setOpen}
      tableRowProps={(row => ({ selected: row.shared }))}
      title={title}
    />
  );
};

Repositories.propTypes = {
  className: PropTypes.string,
  group: PropTypes.object.isRequired,
  onShareRepository: PropTypes.func,
  title: PropTypes.string,
};

Repositories.defaultProps = {
  group: {
    allRepositories: [],
    repositories: []
  }
};

export default Repositories;
